import { type ApiConfig } from '../../../common/types';
import ApiConfigInfo from '../components/ApiConfigInfo';
import Breadcrumb from '../../../components/Breadcrumb';
import DeleteApiConfig from '../components/DeleteApiConfig';
import EditApiConfigV2 from '../components/EditApiConfig';
import ListApiConfigs from '../components/ListApiConfigs';
import LoadingSpinner from '../../../components/LoadingSpinner';
import Pagination from '../../../components/Pagination';
import SuccessMessage from '../../../components/success-message';
import { useGetAllQuery } from '../sticky-config.api-slice';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ListApiConfigsPage: React.FC = () => {
  const [page, setPage] = useState<number>(1);
  const { data: apiConfigs, isLoading } = useGetAllQuery({ page });
  const { t } = useTranslation();
  const [infoItem, setInfoItem] = useState<ApiConfig | null>(null);
  const [editingItem, setEditingItem] = useState<ApiConfig | null>(null);
  const [deletingItem, setDeletingItem] = useState<ApiConfig | null>(null);
  const [openInfoModal, setOpenInfoModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

  const toggleInfoModal = (): void => {
    if (openInfoModal) {
      setInfoItem(null);
    }
    setOpenInfoModal(!openInfoModal);
  };
  const toggleEditModal = (): void => {
    if (openEditModal) {
      setEditingItem(null);
    }
    setOpenEditModal(!openEditModal);
  };

  const toggleDeleteModal = (): void => {
    if (openDeleteModal) {
      setDeletingItem(null);
    }
    setOpenDeleteModal(!openDeleteModal);
  };

  const handleInfoItem = (item: ApiConfig | null): void => {
    setInfoItem(item);
  };

  const handleEditingItem = (item: ApiConfig | null): void => {
    setEditingItem(item);
  };

  const handleDeletingItem = (item: ApiConfig | null): void => {
    setDeletingItem(item);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <div className="pb-4">
        <h1>{t('apiConfigs.list.title')}</h1>
        <Breadcrumb
          items={[{ label: t('common.adminBreadcrumbLabel') }, { label: t('apiConfigs.list.breadcrumbLabel') }]}
        />
      </div>
      <div className="w-full flex justify-between items-center">
        <h1>{t('apiConfigs.list.heading')}</h1>
      </div>

      <ApiConfigInfo isOpen={openInfoModal} toggleModal={toggleInfoModal} item={infoItem} />
      <EditApiConfigV2 isOpen={openEditModal} toggleEditModal={toggleEditModal} item={editingItem} />

      <DeleteApiConfig isOpen={openDeleteModal} toggleDeleteModal={toggleDeleteModal} item={deletingItem} />

      {apiConfigs?.data == null ||
        (apiConfigs.data.length === 0 && <SuccessMessage message={t('apiConfigs.list.empty')} type="error" />)}

      {apiConfigs?.data != null && apiConfigs.data.length > 0 && (
        <>
          <ListApiConfigs
            items={apiConfigs.data}
            toggleInfoModal={toggleInfoModal}
            toggleEditModal={toggleEditModal}
            toggleDeleteModal={toggleDeleteModal}
            handleInfoItem={handleInfoItem}
            handleEditingItem={handleEditingItem}
            handleDeletingItem={handleDeletingItem}
          />
          <Pagination pageData={apiConfigs.meta} handlePageChange={setPage} />
        </>
      )}
    </div>
  );
};

export default ListApiConfigsPage;
